<template>
  <div class="warning">
		<span class="warning__icon" aria-hidden="true">!</span>
    <p class="gamma bold">{{title}}</p>   
	</div>
</template>

<script>
export default {
	name: 'WarningCalloutAlt',
	props: {
		title: String
	},
}
</script>